import { AxiosResponse } from "axios";
import { ICruisesOperators } from "@/interfaces/ICruisesOperators";
import { IAllCruisesList } from "@/interfaces/IAllCruisesList";
import Airport from "@/interfaces/IAirport";
import { IUniqCruise } from "@/interfaces/IUniqCruise";
import { AllShips } from "@/interfaces/IShips";
import { UniqueShip } from "@/interfaces/IUniqueShip";
import { UniqueCruise } from "@/interfaces/IUniqueCruise";
import { PortVisit } from "@/interfaces/IPortVisit";
import { SiteServices } from "@/interfaces/ISiteServices";
import { IweatherMarine } from "@/interfaces/IweatherMarine";
import { SearchData } from "@/interfaces/SeachData";
import { createBoApiClient } from "./boApiHttp";

const siteCode = process.env.NEXT_PUBLIC_SITE_CODE || "wcv";
// const http = axios.create({ baseURL: process.env.NEXT_PUBLIC_BO_API });
const http = createBoApiClient();

export const getAllCruisesListV2 = (
  params: {
    operator?: string;
    shipName?: string;
    charter?: string;
    s?: "starts_on asc"; //fot acending date
    StartDateRangeBeginning?: string;
    StartDateRangeEnd?: string;
    region?: string;
    startFrom?: string;
    cruiseType?: string;
    limit?: number;
    page?: number;
    type?: string;
    profileImageGeometry?: string;
    coverImageGeometry?: string;
  },
  options?: { signal?: AbortSignal }, //this was check multiple refuse send or not by fe to api same time
) => {
  const filteredParams = Object.fromEntries(
    Object.entries(params)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, value]) => value !== undefined && value !== null),
  );
  // const baseURL = `/public/cruises?siteCode=${siteCode}`;
  // const fullURL = `${baseURL}&${new URLSearchParams(filteredParams as Record<string, string>).toString()}`;
  return http.get<IAllCruisesList>(`/public/cruises?siteCode=${siteCode}`, {
    params: filteredParams,
    signal: options?.signal,
  });
};

// Cruisline
export const getCruiseOperators = (
  limit?: number,
  page?: number,
  mgm?: boolean,
  profileImageGeometry?: string,
) => {
  return http.get<ICruisesOperators>(`/public/cruises/operators`, {
    params: { siteCode, limit, page, mgm, profileImageGeometry },
  });
};

// CruislineUniq
export const getUnicqeCruiseOperators = (slug: string) => {
  return http.get<IUniqCruise>(
    `/public/cruises/operators/unique-operator?OperatorRef=${slug}&siteCode=${siteCode}`,
  );
};

export const getAllLocations = (limit?: number, sf?: boolean) => {
  return http.get(`/public/cruises/ports`, { params: { siteCode, limit, sf } });
};

export const searchAirport = (keyword: string): Promise<AxiosResponse<Airport[]>> => {
  return http.get<Airport[]>("/DestinationsList/search-destinations-list", {
    params: {
      keyword,
    },
  });
};

export const getUniqueCruise = (cruiseRef: string) => {
  return http.get<UniqueCruise>("/public/cruises/unique-cruise", {
    params: {
      cruiseRef,
      siteCode,
    },
  });
};

export const getUniqueShip = (
  ShipRef: string,
  imagesGeometry = "700x",
  deckplanImagesGeometry = "x400",
) => {
  // const resizeParams = {
  //   profileImageGeometry: "600x",
  //   coverImageGeometry: "600x",
  //   imagesGeometry: "600x",
  //   uniqFeatureImagesGeometry: "600x",
  //   deckplanImagesGeometry: "600x",
  //   accomodationTypeImagesGeometry: "600x",
  //   diningOptionImagesGeometry: "600x",
  //   entertainmentTypeImagesGeometry: "600x",
  //   healthFitnessTypeImagesGeometry: "600x",
  //   kidTeenTypeImagesGeometry: "600x",
  //   enrichmentTypeImagesGeometry: "600x",
  // };
  return http.get<UniqueShip>("/public/cruises/ships/unique-ship", {
    params: {
      ShipRef,
      imagesGeometry: imagesGeometry,
      deckplanImagesGeometry: deckplanImagesGeometry,
      siteCode,
    },
  });
};

export const portVisitUniqueCruise = (cruiseRef: string) => {
  return http.get<PortVisit[]>("/public/cruises/port-visit/unique-cruise", {
    params: {
      cruiseRef,
      siteCode,
    },
  });
};

export const getAllShipData = (limit?: number, page?: number, operator?: string) => {
  return http.get<AllShips>("/public/cruises/ships", {
    params: {
      siteCode,
      limit,
      page,
      operator,
    },
  });
};

export const getSiteService = () =>
  http.get<SiteServices[]>(`/public/site-services`, {
    params: {
      siteCode,
    },
  });

export const subscribeToNewsLetter = (params: {
  email: string;
  firstName: string;
  lastName: string;
  mobile: string;
  countryOrLocation?: string;
}) => {
  return http.get("/newsletter-subscription/public/otp-request", {
    params: { ...params, siteCode },
  });
};

export const createNewsletter = (params: {
  firstName: string;
  lastName: string;
  email: string;
  countryOrLocation?: string;
  status: boolean;
  siteCode: string;
  mobile: string;
  otp: string;
}): Promise<AxiosResponse<{ id: number }>> => {
  return http.get(`/newsletter-subscription/public`, {
    params: { ...params, siteCode },
  });
};

interface IPageSeo {
  id: number;
  title: string;
  metaDescription: string;
  keywords: string;
  siteUrl: string;
  siteCodeId: number;
  siteCode: string;
  canonicalUrl?: string;
}
export const getPageSeo = (pageUrl: string) => {
  return http.get<IPageSeo>(`/sitepagesseo/public`, {
    params: {
      pageUrl,
      siteCode,
    },
  });
};

export const getweatherMarine = (q: string, days: number) => {
  return http.get<IweatherMarine>(`/weather/public/marine-weather`, {
    params: {
      siteCode,
      q,
      days, //max 7 days
    },
  });
};

export const searchTravel = (params: { keyword: string }): Promise<AxiosResponse<SearchData>> => {
  return http.get(`public/search/travel`, {
    params: { ...params, siteCode },
  });
};
